/**
 * VenueBookingService
 * Service for VenueBooking entity operations
 * Route: api/venuebookings
 * Controller: VenueBookingsController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * VenueBookingService
 * Handles venue booking CRUD operations and custom endpoints
 * Maps to /api/venuebookings endpoint
 */
export class VenueBookingService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VenueBookingService.DEFAULT_SERVICE_PATH,
            basePath: VenueBookingService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Get all venue bookings for a venue
     * GET /api/venuebookings/GetByVenue/{venueId}
     * @param venueId - Venue ID
     * @returns Array of venue bookings
     */
    async getByVenue(venueId) {
        const response = await this.getByVenueRaw(venueId);
        return response.data ?? [];
    }
    getByVenueRaw(venueId) {
        const url = this.buildUrl('GetByVenue/' + venueId);
        return this.http.get(url);
    }
    /**
     * Get all venue bookings for a meeting
     * GET /api/venuebookings/GetByMeeting/{meetingId}
     * @param meetingId - Meeting ID
     * @returns Array of venue bookings
     */
    async getByMeeting(meetingId) {
        const response = await this.getByMeetingRaw(meetingId);
        return response.data ?? [];
    }
    getByMeetingRaw(meetingId) {
        const url = this.buildUrl('GetByMeeting/' + meetingId);
        return this.http.get(url);
    }
    /**
     * Approve a pending venue booking — sets status Confirmed and stamps
     * ApprovedBy/ApprovedDateTime.
     * POST /api/venuebookings/approve/{id}
     * @param id - Venue booking ID
     * @returns The approved venue booking
     */
    async approve(id) {
        const response = await this.approveRaw(id);
        if (!response.data) {
            throw new Error(`Failed to approve venue booking ${id}`);
        }
        return response.data;
    }
    approveRaw(id) {
        const url = this.buildUrl('approve/' + id);
        return this.http.post(url, {});
    }
}
VenueBookingService.DEFAULT_SERVICE_PATH = 'meetings';
VenueBookingService.BASE_PATH = 'api/venuebookings';
//# sourceMappingURL=VenueBookingService.js.map